import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Link,
  useNavigate,
  NavLink,
  useParams,
} from "react-router-dom";
import Cookies from "js-cookie";
import {
  Avatar,
  Box,
  IconButton,
  Menu,
  MenuItem,
  Badge,
  Typography,
  styled,
  Drawer,
} from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";
import LogoutIcon from "@mui/icons-material/Logout";
import ActivateLogo from "../../../assets/images/activate-logo.svg";
import { logout } from "../../../store/slice/auth.slice";
import {
  useFetchManagerNotificationQuery,
  useFetchUserNotificationQuery,
  useUpdateNotificationMutation,
} from "../../../services/headerService";
// import MoreVertIcon from "@mui/icons-material/MoreVert";
import MenuIcon from "@mui/icons-material/Menu";
import { appConfig } from "../../../config/app.config";
import { jwtDecode } from "jwt-decode";

import CircleNotificationsIcon from "@mui/icons-material/CircleNotifications";

const Header = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);

  const [isJwt, setJwt] = useState(false);
  const { id: param } = useParams();
  const navigate = useNavigate();

  // Decode JWT token and set state
  useEffect(() => {
    try {
      const decoded = jwtDecode(param); // Decode JWT token
      if (decoded?.user_id) {
        setJwt(true); // Set isJwt to true if user_id exists
      } else {
        setJwt(false); // Set isJwt to false if user_id doesn't exist
      }
    } catch (error) {
      setJwt(false); // If the decoding fails, set isJwt to false
    }
  }, [param]);

  // const [notifications, setNotifications] = useState([]);
  // const [isReadAll, setIsReadAll] = useState([]);

  const [anchorProfile, setAnchorProfile] = useState(null);
  const [anchorNotification, setAnchorNotification] = useState(null);
  const openProfileMenu = Boolean(anchorProfile);
  const openNotificationMenu = Boolean(anchorNotification);

  // RTK Query hooks

  // console.log(user?.data?.user_id);
  // console.log(user?.data?.manager_id);

  // if (user?.user_id) {

  // } else {

  // }
  const [updateNotification] = useUpdateNotificationMutation();
  // const [postLogout] = usePostLogoutMutation();

  // const { data: managerNotificationsData, isLoading: isManagerNotificationsLoading,refetch:manager_fecthing } =
  //   useFetchManagerNotificationQuery(user?.manager_id, {
  //     skip: user?.role !== 'manager',
  //   });
  // const { data: userNotificationsData, isLoading: isUserNotificationsLoading ,refetch:user_fetching} =
  //   useFetchUserNotificationQuery(user?.user_id, {
  //     skip: user?.role !== 'employee',
  //   });

  const {
    data: managerNotificationsData,
    // isLoading: isManagerNotificationsLoading,
    refetch: manager_fecthing,
  } = useFetchManagerNotificationQuery(undefined, {
    skip: user?.role !== "manager", // Only fetch if user is a manager
  });
  const {
    data: userNotificationsData,
    // isLoading: isUserNotificationsLoading,
    refetch: user_fetching,
  } = useFetchUserNotificationQuery(undefined, {
    skip: user?.role !== "employee", // Only fetch if user is an employee
  });

  const notificationsData = useMemo(() => {
    if (user?.role === "employee" && userNotificationsData) {
      return userNotificationsData;
    } else if (user?.role === "manager" && managerNotificationsData) {
      return managerNotificationsData;
    } else {
      return [];
    }
  }, [user?.role, userNotificationsData, managerNotificationsData]);

  // Update notifications state when data changes
  // useEffect(() => {
  //   console.log(notificationsData)
  //   if (notificationsData) {
  //     setNotifications(notificationsData);
  //     // setNotifications(Array.isArray(notificationsData) ? notificationsData : []);
  //   }
  // }, [notificationsData]);
  useEffect(() => {
    // Fetch notifications on login
    if (user?.role === "employee") {
      user_fetching(); // Trigger fetching for employee notifications
    } else if (user?.role === "manager") {
      manager_fecthing(); // Trigger fetching for manager notifications
    }
  }, [user, user?.role, user_fetching, manager_fecthing]);
  const handleNotificationMenuClick = (event) => {
    setAnchorNotification(event.currentTarget);
  };
  const notificationsDataArray = Array.isArray(notificationsData?.data)
    ? notificationsData?.data
    : [];

  const handleCloseProfileMenu = () => {
    setAnchorProfile(null);
  };

  const handleProfileMenuClick = (event) => {
    setAnchorProfile(event.currentTarget);
  };
  const handleCloseNotificationMenu = () => {
    setAnchorNotification(null);
    markAllNotificationsAsRead();
  };

  const markAllNotificationsAsRead = async () => {
    const unreadNotifications = notificationsDataArray.filter(
      (n) => !n.is_read
    );

    if (unreadNotifications.length > 0) {
      try {
        for (const notification of unreadNotifications) {
          console.log(notification.id);
          await markNotificationAsRead(notification.id);
        }
      } catch (error) {
        console.error("Error marking all notifications as read:", error);
      }
    }
  };
  // const markAllNotificationsAsRead = async () => {
  //   const unreadNotifications = notificationsDataArray.filter((n) => !n.is_read);
  //   console.log(unreadNotifications)
  //   if (unreadNotifications.length > 0) {
  //     try {
  //       // Send requests to mark all notifications as read
  //       await Promise.all(
  //         unreadNotifications.map((notification) => updateNotification(notification.id))
  //       );

  //       // Update local state

  //     } catch (error) {
  //       console.error("Error marking all notifications as read:", error);
  //     }
  //   }
  // };
  const [anchorHamburger, setAnchorHamburger] = useState(null);
  // const openHamburgerMenu = Boolean(anchorHamburger);

  const handleHamburgerMenuClick = (event) => {
    setAnchorHamburger(event.currentTarget);
  };
  const handleCloseHamburgerMenu = () => {
    setAnchorHamburger(null);
  };

  const markNotificationAsRead = async (notificationId) => {
    try {
      const response = await updateNotification(notificationId);
      console.log(response)

      // console.log("notiiiiiiii",notifications)
      // setNotifications((prev) => ({
      //   ...prev,
      //   data: prev.data.map((notif) =>
      //     notif.id === notificationId ? { ...notif, is_read: true } : notif

      //   ),
      // }));
      // console.log("newwww   notiiiiiiii",notifications)
      if (user?.role === "employee") {
        user_fetching();
      }
      manager_fecthing();
    } catch (error) {
      console.error("Error marking notification as read:", error);
    }
  };

  const handleLogout = async () => {
    try {
      // Get the token from localStorage
      // const authState = localStorage.getItem("auth");
      // const parsedAuthState = authState ? JSON.parse(authState) : null;

      // if (parsedAuthState) {
      //   const token = parsedAuthState.user?.data?.token;
  
        
      //   // Use the mutation to log the user out
      //   // await postLogout(token).unwrap();
      // }

      // Dispatch the logout action to clear Redux state
      dispatch(logout());

      // Clear local storage
      localStorage.removeItem("auth");
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      Cookies.remove(appConfig.tokenName);

      // Redirect to the login page
      navigate("/");
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  // const markAllNotificationsAsRead = async () => {
  //   const unreadNotifications = notifications.filter((n) => !n.is_read);
  //   if (unreadNotifications.length > 0) {
  //     try {
  //       for (const notification of unreadNotifications) {
  //         await markNotificationAsRead(notification.id);
  //       }
  //     } catch (error) {
  //       console.error("Error marking all notifications as read:", error);
  //     }
  //   }
  // };

  const initials = user?.name
    ? `${user.name.charAt(0)}${user.name.split(" ")[1]?.charAt(0)}`
    : "";

  return (
    <SectionWrap component="header">
      <ContainerWrap>
        <RowWrap>
          <Col6Wrap>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              {/* <Box sx={{ display: { xs: "none", md: "flex" }, alignItems: "center", marginLeft: "20px" }}> */}
              {/* <Link
                to={
                  user?.role === "employee"
                    ? "/landing-page"
                    : "/manager-dashboard"
                }
              >
                <img
                  src={ActivateLogo}
                  alt="Activate Logo"
                  width="238"
                  height="90"
                  style={{ maxWidth: "140px", height: "auto" }}
                />
              </Link> */}
             {!isJwt ? (
                user?.role === "superadmin" ? (
                    <Link to="/view-org">
                        <img
                          src={ActivateLogo}
                          alt="Activate Logo"
                          width="238"
                          height="90"
                          style={{ maxWidth: "140px", height: "auto" }}
                        />
                    </Link>
                ) : (
                  <Link
                    to={user?.role === "employee" ? "/landing-page" : "/manager-dashboard"}
                  >
                    <img
                      src={ActivateLogo}
                      alt="Activate Logo"
                      width="238"
                      height="90"
                      style={{ maxWidth: "140px", height: "auto" }}
                    />
                  </Link>
                )
              ) : (
                <img
                  src={ActivateLogo}
                  alt="Activate Logo"
                  width="238"
                  height="90"
                  style={{ maxWidth: "140px", height: "auto" }}
                />
              )}
              <Box
                sx={{
                  display: { xs: "none", md: "flex" },
                  alignItems: "center",
                  marginLeft: "20px",
                }}
              >
                {user?.role === "employee" ? (
                  <>
                    <NavLink
                      to="/history"
                      style={({ isActive }) => ({
                        textDecoration: "none",
                        fontSize: "14px",
                        fontWeight: "500",
                        margin: "0 10px",
                        color: isActive ? "#1085AB" : "#2C2C2E", // Automatically highlight active link
                      })}
                    >
                      Dashboard
                    </NavLink>

                    <NavLink
                      to="/user-reports"
                      style={({ isActive }) => ({
                        textDecoration: "none",
                        fontSize: "14px",
                        fontWeight: "500",
                        margin: "0 10px",
                        color: isActive ? "#1085AB" : "#2C2C2E", // Automatically highlight active link
                      })}
                    >
                      Report versions
                    </NavLink>
                    <NavLink
                      to="/user_details-steps"
                      style={({ isActive }) => ({
                        textDecoration: "none",
                        fontSize: "14px",
                        fontWeight: "500",
                        margin: "0 10px",
                        color: isActive ? "#1085AB" : "#2C2C2E", // Automatically highlight active link
                      })}
                    >
                      RoleReview
                    </NavLink>
                  </>
                ) : user?.role === "superadmin" ? (
                  <NavLink
                    to="/view-org"
                    style={({ isActive }) => ({
                      textDecoration: "none",
                      fontSize: "14px",
                      fontWeight: "500",
                      margin: "0 10px",
                      color: isActive ? "#1085AB" : "#2C2C2E", // Automatically highlight active link
                    })}
                  >
                    Organizations
                  </NavLink>
                ) : null}
              </Box>
            </Box>
          </Col6Wrap>

          <Col6Wrap>
            <Box
              sx={{
                display: "flex",
                justifyContent: "end",
                alignItems: "center",
              }}
            >
              <IconButton
                onClick={handleHamburgerMenuClick}
                sx={{
                  display: {
                    xs: "block",
                    md: "none",
                    position: "absolute",
                    right: "10px",
                    top: "7px",
                  },
                }}
              >
                <MenuIcon />
              </IconButton>

              {/* Drawer for Mobile Menu */}
              <Drawer
                anchor="left"
                open={anchorHamburger}
                onClose={handleCloseHamburgerMenu}
              >
                <Box sx={{ width: "250px", padding: "20px" }}>
                  <Typography variant="h6">Menu</Typography>
                  <NavLink to="/history" onClick={handleHamburgerMenuClick}>
                    Dashboard
                  </NavLink>
                  <NavLink
                    to="/user-reports"
                    onClick={handleHamburgerMenuClick}
                  >
                    Report Versions
                  </NavLink>
                  <NavLink
                    to="/user_details-steps"
                    onClick={handleHamburgerMenuClick}
                  >
                    RoleReview
                  </NavLink>
                </Box>
              </Drawer>
              {/* Notifications Icon */}
              {user?.role === "employee" && (
                <IconButton
                  onClick={handleNotificationMenuClick}
                  size="small"
                  sx={{
                    padding: "0",
                    marginRight: { xs: "5px", sm: "15px" },
                  }}
                  aria-controls={
                    openNotificationMenu ? "notification-menu" : undefined
                  }
                  aria-haspopup="true"
                  aria-expanded={openNotificationMenu ? "true" : undefined}
                >
                  <Badge
                    color="error"
                    variant="dot"
                    invisible={
                      !notificationsDataArray.some((notif) => !notif.is_read)
                    }
                    sx={{
                      "& .MuiBadge-badge": {
                        top: "10px",
                        right: "10px",
                      },
                    }}
                  >
                    <CircleNotificationsIcon
                      fontSize="large"
                      sx={{
                        fill: "#bdbdbd",
                        width: { xs: "35px", sm: "48px" }, // Smaller icon on mobile (xs), larger on desktop (sm)
                        height: "auto",
                      }}
                    />
                  </Badge>
                </IconButton>
              )}

              <Menu
                id="notification-menu"
                anchorEl={anchorNotification}
                open={openNotificationMenu}
                onClose={handleCloseNotificationMenu}
                PaperProps={{
                  style: { maxHeight: 300, width: "300px" },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                {notificationsDataArray.length > 0 ? (
                  notificationsDataArray.map((notification) => (
                    <MenuItem
                      key={notification.id}
                      onClick={() => {
                        markNotificationAsRead(notification.id);
                        handleCloseNotificationMenu();
                      }}
                      sx={{
                        backgroundColor: notification.is_read
                          ? "#f5f5f5"
                          : "#fff",
                      }}
                    >
                      <Typography
                        sx={{ whiteSpace: "break-spaces" }}
                        variant="body2"
                      >
                        {notification.message}
                      </Typography>
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem>
                    <Typography
                      sx={{ whiteSpace: "break-spaces" }}
                      variant="body2"
                    >
                      No notifications
                    </Typography>
                  </MenuItem>
                )}
              </Menu>

              {/* Profile Icon */}
              {/* <IconButton
                onClick={handleProfileMenuClick}
                size="small"
                sx={{ padding: "0", marginLeft: { xs: "2px", sm: "10px" },marginRight: { xs: "45px", sm: "10px" },  }}
                
                aria-controls={openProfileMenu ? "account-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={openProfileMenu ? "true" : undefined}
              >
                <Avatar sx={{ width: { xs: "30px", sm: "40px" }, height: { xs: "30px", sm: "40px" } }}>{initials}</Avatar>
              </IconButton> */}
              {!isJwt && (
                <IconButton
                  onClick={handleProfileMenuClick}
                  size="small"
                  sx={{
                    padding: "0",
                    marginLeft: { xs: "2px", sm: "10px" },
                    marginRight: { xs: "45px", sm: "10px" },
                  }}
                  aria-controls={openProfileMenu ? "account-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={openProfileMenu ? "true" : undefined}
                >
                  <Avatar
                    sx={{
                      width: { xs: "30px", sm: "40px" },
                      height: { xs: "30px", sm: "40px" },
                    }}
                  >
                    {initials}
                  </Avatar>
                </IconButton>
              )}
              <Menu
                id="account-menu"
                anchorEl={anchorProfile}
                open={openProfileMenu}
                onClose={handleCloseProfileMenu}
                PaperProps={{
                  style: { minWidth: "200px" },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                {/* <MenuItem
                  onClick={() => navigate(`/employee/profile/basic-info`)}
                >
                  <PersonIcon fontSize="small" />
                  <Typography variant="body2" sx={{ ml: 1 }}>
                    My Profile
                  </Typography>
                </MenuItem> */}

                {/* <MenuItem
                  onClick={() =>
                    navigate(`/employee/profile/${user?.user_id}`)
                  }

                  <SettingsIcon fontSize="small" />
                  <Typography variant="body2" sx={{ ml: 1 }}>
                    Settings
                  </Typography>
                </MenuItem> */}
                {user?.role === "employee" && (
                  <MenuItem
                    onClick={() =>
                      // navigate(`/employee/profile/${user?.user_id}`)
                      navigate("/employee/profile/basic-info")
                    }
                  >
                    <SettingsIcon fontSize="small" />
                    <Typography variant="body2" sx={{ ml: 1 }}>
                      My Profile
                    </Typography>
                  </MenuItem>
                )}
                <MenuItem onClick={handleLogout}>
                  <LogoutIcon fontSize="small" />
                  <Typography variant="body2" sx={{ ml: 1 }}>
                    Logout
                  </Typography>
                </MenuItem>
              </Menu>
            </Box>
          </Col6Wrap>
        </RowWrap>
      </ContainerWrap>
    </SectionWrap>
  );
};

export default Header;
const SectionWrap = styled(Box)(() => ({
  background: "#ffffff",
  padding: "15px 0",
  borderBottom: "1px solid #dddddd",
  "@media (max-width: 575px)": {
    padding: "10px 0",
  },
}));

const ContainerWrap = styled(Box)(() => ({
  width: "100%",
  maxWidth: "100%",
  paddingLeft: "15px",
  paddingRight: "15px",
  marginLeft: "auto",
  marginRight: "auto",
}));

const RowWrap = styled(Box)(() => ({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  marginLeft: "-15px",
  marginRight: "-15px",
}));

const Col6Wrap = styled(Box)(() => ({
  flex: "0 0 auto",
  width: "50%",
  maxWidth: "100%",
  paddingLeft: "15px",
  paddingRight: "15px",
  "@media (max-width: 575px)": {
    width: "100%", // Make columns full width on mobile
    paddingLeft: "5px",
    paddingRight: "5px",
  },
}));

// const SectionWrap = styled(Box)(() => ({
//   background: "#ffffff",
//   padding: "15px 0",
//   borderBottom: "1px solid #dddddd",
//   "@media (max-width: 575px)": {
//     padding: "5px 0",
//   },
// }));
// const ContainerWrap = styled(Box)(() => ({
//   width: "100%",
//   maxWidth: "100%",
//   paddingLeft: "15px",
//   paddingRight: "15px",
//   marginLeft: "auto",
//   marginRight: "auto",
// }));
// const RowWrap = styled(Box)(() => ({
//   display: "flex",
//   flexWrap: "wrap",
//   alignItems: "center",
//   marginLeft: "-15px",
//   marginRight: "-15px",
// }));

// const Col6Wrap = styled(Box)(() => ({
//   flex: "0 0 auto",
//   width: "50%",
//   maxWidth: "100%",
//   paddingLeft: "15px",
//   paddingRight: "15px",
// }));
